// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { md3 } from "vuetify/blueprints";

// Vuetify
import { createVuetify } from "vuetify";

export default createVuetify({
  blueprint: md3,
  theme: {
    defaultTheme: "primaryLight", // Set the default theme to 'light'
    themes: {
      light: {},
      dark: {},
      primaryLight: {
        dark: false,
        colors: {
          primary: "#2F4D3D",
          secondary: "#A97842",
          background: "#F5F1E9",
          surface: "#FCFAF6",
          error: "#B00020",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00",
          accent: "#5A7D66",
        },
      },
    },
  },
});
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
